export var EElCompoents;
(function(EElCompoents) {
  EElCompoents["El_alert"] = "el-alert";
  EElCompoents["El_aside"] = "el-aside";
  EElCompoents["El_autocomplete"] = "el-autocomplete";
  EElCompoents["El_badge"] = "el-badge";
  EElCompoents["El_breadcrumb"] = "el-breadcrumb";
  EElCompoents["El_breadcrumb_item"] = "el-breadcrumb-item";
  EElCompoents["El_button"] = "el-button";
  EElCompoents["El_button_group"] = "el-button-group";
  EElCompoents["El_card"] = "el-card";
  EElCompoents["El_carousel"] = "el-carousel";
  EElCompoents["El_carousel_item"] = "el-carousel-item";
  EElCompoents["El_cascader"] = "el-cascader";
  EElCompoents["El_checkbox"] = "el-checkbox";
  EElCompoents["El_checkbox_button"] = "el-checkbox-button";
  EElCompoents["El_checkbox_group"] = "el-checkbox-group";
  EElCompoents["El_col"] = "el-col";
  EElCompoents["El_collapse"] = "el-collapse";
  EElCompoents["El_collapse_item"] = "el-collapse-item";
  EElCompoents["El_color_picker"] = "el-color-picker";
  EElCompoents["El_container"] = "el-container";
  EElCompoents["El_date_picker"] = "el-date-picker";
  EElCompoents["El_dialog"] = "el-dialog";
  EElCompoents["El_dropdown"] = "el-dropdown";
  EElCompoents["El_dropdown_item"] = "el-dropdown-item";
  EElCompoents["El_dropdown_menu"] = "el-dropdown-menu";
  EElCompoents["El_footer"] = "el-footer";
  EElCompoents["El_form"] = "el-form";
  EElCompoents["El_form_item"] = "el-form-item";
  EElCompoents["El_header"] = "el-header";
  EElCompoents["El_input"] = "el-input";
  EElCompoents["El_input_number"] = "el-input-number";
  EElCompoents["El_loading"] = "el-loading";
  EElCompoents["El_main"] = "el-main";
  EElCompoents["El_menu"] = "el-menu";
  EElCompoents["El_menu_item"] = "el-menu-item";
  EElCompoents["El_menu_item_group"] = "el-menu-item-group";
  EElCompoents["El_message"] = "el-message";
  EElCompoents["El_message_box"] = "el-message-box";
  EElCompoents["El_notification"] = "el-notification";
  EElCompoents["El_option"] = "el-option";
  EElCompoents["El_option_group"] = "el-option-group";
  EElCompoents["El_pagination"] = "el-pagination";
  EElCompoents["El_popover"] = "el-popover";
  EElCompoents["El_progress"] = "el-progress";
  EElCompoents["El_rate"] = "el-rate";
  EElCompoents["El_radio"] = "el-radio";
  EElCompoents["El_radio_button"] = "el-radio-button";
  EElCompoents["El_radio_group"] = "el-radio-group";
  EElCompoents["El_row"] = "el-row";
  EElCompoents["El_select"] = "el-select";
  EElCompoents["El_slider"] = "el-slider";
  EElCompoents["El_step"] = "el-step";
  EElCompoents["El_steps"] = "el-steps";
  EElCompoents["El_submenu"] = "el-submenu";
  EElCompoents["El_switch"] = "el-switch";
  EElCompoents["El_table"] = "el-table";
  EElCompoents["El_table_column"] = "el-table-column";
  EElCompoents["El_tag"] = "el-tag";
  EElCompoents["El_tabs"] = "el-tabs";
  EElCompoents["El_tab_pane"] = "el-tab-pane";
  EElCompoents["El_timeline"] = "el-timeline";
  EElCompoents["El_timeline_item"] = "el-timeline-item";
  EElCompoents["El_time_picker"] = "el-time-picker";
  EElCompoents["El_time_select"] = "el-time-select";
  EElCompoents["El_tooltip"] = "el-tooltip";
  EElCompoents["El_transfer"] = "el-transfer";
  EElCompoents["El_tree"] = "el-tree";
  // tree_data
  EElCompoents["El_upload"] = "el-upload";
  EElCompoents["El_link"] = "el-link";
  EElCompoents["El_divider"] = "el-divider";
  EElCompoents["El_icon"] = "el-icon";
  EElCompoents["El_calendar"] = "el-calendar";
  EElCompoents["El_image"] = "el-image";
  EElCompoents["El_backtop"] = "el-backtop";
  EElCompoents["El_infinite_scroll"] = "el-infinite-scroll";
  EElCompoents["El_page_header"] = "el-page-header";
  EElCompoents["El_avatar"] = "el-avatar";
  EElCompoents["El_drawer"] = "el-drawer";
  EElCompoents["El_popconfirm"] = "el-popconfirm";
})(EElCompoents || (EElCompoents = {}));
export var EComponentType;
(function(EComponentType) {
  EComponentType[(EComponentType["DefineComponents"] = 0)] = "DefineComponents";
  EComponentType[(EComponentType["BasicComponent"] = 1)] = "BasicComponent";
  EComponentType[(EComponentType["FormComponent"] = 2)] = "FormComponent";
})(EComponentType || (EComponentType = {}));
// export const componentListService = new ComponentListService();
